<template>
  <div>
    <div app class="white pl-5 pr-5 pt-4 pb-4 d-flex">
      <v-toolbar-title class="text-h4 font-weight-bold">
        {{ this.title.toUpperCase() }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="search"></slot>
      <slot name="actions" class="ml-4"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePageTitle",
  props: {
    title: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  }
};
</script>
